"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const parseNumber = (number, digits = 3) => {
    return parseFloat(new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: digits,
    }).format(number));
};
exports.default = parseNumber;
